import UAParser from 'ua-parser-js'

/**
 * User Agent infos
 */
let ua: UAParser | null = null

if (import.meta.env && import.meta.env.SSR === false) {
  ua = new UAParser()
}

export { ua }

/**
 * URLs, segments, endpoints
 */
export const endpointDefault = 'pages'

/**
 * API URLs
 */
export const getApiUrl = () =>
  `${import.meta.env.VITE_API_DOMAIN}${import.meta.env.VITE_API_PATH}`
export const getThumborUrl = () =>
  `${import.meta.env.VITE_API_DOMAIN}${import.meta.env.VITE_THUMBOR_PATH}`

/**
 * GTM ID
 */
export const gtmId = 'GTM-TS2WH6VH'
export const useGtm = true

/**
 * Google Site Verification
 */
// export const googleSite = 'xxx_yyyzzzzzzz'
export let googleSite: string

/**
 * Options
 */
export const emoji = '🔮'
export const darkModeOptions = {
  selector: 'html',
  attribute: 'color-scheme',
  valueDark: 'dark',
  valueLight: 'light',
}

// Grid
export const gridCols = 24

// Icons
export const iconViewbox = '0 0 24 24'
/* eslint-disable quote-props */
export const iconRegistered: Record<
  string,
  { symbol: string; viewbox?: string }
> = {
  arrow: { symbol: 'arrows-large-right' },
  'arrow-long-left': { symbol: 'ui-arrow-long-left' },
  'arrow-long-right': { symbol: 'ui-arrow-long-right' },
  download: { symbol: 'ui-download' },
  calendar: { symbol: 'ui-calendar' },
  play: { symbol: 'ui-play' },
} // as const
